/**
 * Checks if the file type is valid based on the accept attribute value
 * @param file the selected file to validate
 * @param accept the value passed as the input (upload) field's "accept" attribute
 */
export const isFileAccepted = (file: File, accept?: string): boolean => {
    if (!accept) {
        return true;
    }
    const fileName = file.name.toLowerCase();
    const fileType = file.type.toLowerCase();
    return accept
        .split(",")
        .map((t) => t.trim().toLowerCase())
        .some((accepted) => {
            // extension match: e.g. ".mp4", ".jpg"
            if (accepted.startsWith(".")) {
                return fileName.endsWith(accepted);
            }
            // wildcard MIME type match: e.g. "video/*", "image/*"
            if (accepted.endsWith("/*")) {
                return fileType.startsWith(accepted.slice(0, -1)); // strip "*", keep "video/"
            }
            // exact MIME type match: e.g. "video/mp4", "image/jpeg"
            return fileType === accepted;
        });
};
